import { NoResultsIllustration, StatusScreen } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/mediaspace-shared-utils";
import React from "react";
import styled from "@emotion/styled";

export const NoHistory = () => {
    return (
        <NoResultsScreen
            title={translate("No watch history yet")}
            text={translate("Once you start watching videos, they’ll appear here so you never lose track.")}
            image={<NoResultsIllustration />}
            contentWidth={963}
        />
    );
};

const NoResultsScreen = styled(StatusScreen)({
    "& svg": {
        width: 300,
        height: 300,
    },
});
